/* Chroma configurator · swatches switch the real Shopify variant, recolour the
   accent, swap the cover/spread carousel and update price. Scoped per element so
   it works on both the homepage block and the product page. */
if (!customElements.get('chroma-configurator')) {
  customElements.define(
    'chroma-configurator',
    class ChromaConfigurator extends HTMLElement {
      connectedCallback() {
        this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
        this.idInput = this.querySelector('[name="id"]');
        this.qtyInput = this.querySelector('[name="quantity"]');
        this.symbol = this.dataset.currencySymbol || '£';

        this.els = {
          name: this.querySelector('[data-cfg-name]'),
          roleLabel: this.querySelector('[data-cfg-role-label]'),
          desc: this.querySelector('[data-cfg-desc]'),
          price: this.querySelector('[data-cfg-price]'),
          total: this.querySelector('[data-cfg-total]'),
          qty: this.querySelector('[data-cfg-qty]'),
          cover: this.querySelector('[data-cfg-cover]'),
          spread: this.querySelector('[data-cfg-spread]'),
          dots: Array.from(this.querySelectorAll('[data-cfg-dot]')),
          track: this.querySelector('[data-cfg-track]'),
          spotlight: this.closest('.spotlight') || this,
        };

        this.qty = 1;

        this.swatches.forEach((sw) => {
          sw.addEventListener('click', () => this.select(sw));
        });

        const minus = this.querySelector('[data-qty-minus]');
        const plus = this.querySelector('[data-qty-plus]');
        if (minus) minus.addEventListener('click', () => this.bumpQty(-1));
        if (plus) plus.addEventListener('click', () => this.bumpQty(1));

        if (this.els.track) {
          this.els.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
        }

        const initial = this.swatches.find((s) => s.getAttribute('aria-pressed') === 'true') || this.swatches[0];
        if (initial) this.select(initial, true);
      }

      money(pence) {
        return this.symbol + (pence / 100).toFixed(2);
      }

      select(sw, initial) {
        const d = sw.dataset;
        this.current = d;

        this.swatches.forEach((s) => {
          const on = s === sw;
          s.classList.toggle('on', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (this.idInput) this.idInput.value = d.variantId;

        document.documentElement.style.setProperty('--accent', d.hex);
        const dot = document.querySelector('.brand .dot');
        if (dot) dot.style.background = d.hex;
        if (this.els.spotlight && this.els.spotlight.classList.contains('spotlight')) {
          this.els.spotlight.style.background = d.tint;
        }

        if (this.els.name) this.els.name.textContent = d.name;
        if (this.els.roleLabel) this.els.roleLabel.textContent = d.color + ' · ' + d.role;
        if (this.els.desc) this.els.desc.textContent = d.desc;

        this.unitPence = parseInt(d.price, 10) || 0;
        if (this.els.price) this.els.price.textContent = this.money(this.unitPence);

        if (this.els.cover && d.cover) {
          this.els.cover.src = d.cover;
          this.els.cover.alt = d.coverAlt || d.name + ' cover';
        }
        if (this.els.spread && d.spread) {
          this.els.spread.src = d.spread;
          this.els.spread.alt = d.spreadAlt || d.name + ' inside pages';
        }
        if (this.els.track && !initial) this.els.track.scrollLeft = 0;
        this.syncDots();

        this.qty = 1;
        this.updateQty();
      }

      bumpQty(delta) {
        this.qty = Math.max(1, this.qty + delta);
        this.updateQty();
      }

      updateQty() {
        if (this.qtyInput) this.qtyInput.value = this.qty;
        if (this.els.qty) this.els.qty.textContent = this.qty;
        if (this.els.total) this.els.total.textContent = this.money(this.unitPence * this.qty);
      }

      syncDots() {
        if (!this.els.track || !this.els.dots.length) return;
        const i = Math.round(this.els.track.scrollLeft / this.els.track.clientWidth);
        this.els.dots.forEach((dot, j) => dot.classList.toggle('on', j === i));
      }
    }
  );
}
